import React, { useEffect, useState } from 'react'
import Page from '../../../../component/Page'
import { Link, useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import TitlePage from '../../../../component/TitlePage'
import AddButton from '../../../../component/AddButton'
import { Box, Button, FormControl, MenuItem, Pagination, Select, Skeleton } from '@mui/material'
import InputSearch from '../../../../component/InputSearch'
import dayjs from 'dayjs'
import { getBranchList, getMaterialsTransfersList } from '../../services/api'
import './list.scss'
import ListLayout from '../../../../component/listLayout'
export default function MaterialsTransfersList() {
  const [loading, setLoading] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()
  let id = searchParams.get('id') || ''
  let q = searchParams.get('q') || ''
  let b = searchParams.get('b') || ''
  let page = searchParams.get('page') || '1'
  const [data, setData] = useState([])
  const [rowsPerPage] = useState(10);
  const { profile } = useSelector(state => state.profile)
  const [branchs, setBranchs] = useState([])
  useEffect(() => {
    const getBranch = async () => {
      const data = await getBranchList()
      setBranchs(data)
    }
    getBranch()
  }, [])
  useEffect(() => {
    const getList = async () => {
      setLoading(true)
      const data = await getMaterialsTransfersList(q, b, page, rowsPerPage)
      setData(data)
      setLoading(false)
    }
    getList()
  }, [q, b, page, rowsPerPage])
  const head = [
    'ที่',
    'ศูนย์เมล็ดพันธุ์ข้าวที่โอน',
    'หน่วยงานที่โอน',
    'วันที่เอกสาร',
    'รายการ',
    'ศูนย์เมล็ดพันธุ์ข้าวรับโอน',
    'หน่วยงานที่รับโอน',
    'สถานะ',
    'ดำเนินการ'
  ]
  const body = data?.items?.map((x, i) => {

    return {
      id: x?.DocumentNo,
      item1: (data?.meta?.currentPage - 1) * data?.meta?.itemsPerPage + 1 + i,
      item2: x?.BranchName,
      item3: x?.DepartmentName,
      item4: dayjs(x?.DocumentDate).format('DD/MM/BBBB'),
      item5: x?.ItemName || '',
      item6: x?.ToBranchName,
      item7: x?.ToDepartmentName,
      item8: x?.DocumentStatus === 'Y' ? x?.Status : 'ยกเลิก',
      item9: [<Link to={`/materials/materials-transfers/${x?.DocumentNo}`} onClick={() => setSearchParams({ id: x?.DocumentNo, page: page, q: q, b: b })}>
        <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }}>เรียกดู</Button>
      </Link>]
      ,


    }
  })
  return (
    <ListLayout title={'รายการโอนวัสดุ'} action={<>
      <AddButton link={'/materials/materials-transfers/add'} />
      {
        profile?.BranchNo?.BranchNo === '00' &&
        <Box className="col-lg-2 col-md-12 ">
          <Box className='backgroundField' sx={{ marginRight: '20px' }}>
            <FormControl variant="standard" fullWidth >
              <Select value={b || 'all'}
                onChange={e => setSearchParams({ q: q, b: e.target.value })}
                disableUnderline
                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
              >
                <MenuItem value='all'>ศูนย์ทั้งหมด</MenuItem>
                {branchs?.map((x, i) => (
                  <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Box >
      }
      <InputSearch value={q} onChange={e => setSearchParams({ q: e.target.value, b: b })} placeholder={"ค้นหา เลขที่เอกสาร"} />
    </>} loading={loading} head={head} body={body || []} pagination={{
      count: data?.meta?.totalPages,
      page: +page,
      event: { q: q, b: b, id: id }
    }} id={id}
      setSearchParams={setSearchParams} />
  )
}
